import React from 'react';
import { Clock, CheckCircle2, Wallet, AlertCircle } from 'lucide-react';
import { fmtXof } from './perfMeta';

const Card = ({ icon: Icon, ring, value, label, sub, testid }) => (
  <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5" data-testid={testid}>
    <div className="flex items-center gap-2">
      <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${ring.icon}`}><Icon className="h-4.5 w-4.5" /></span>
      <span className={`rounded-md px-2 py-0.5 text-[10px] font-semibold ${ring.badge}`}>{label}</span>
    </div>
    <p className={`mt-3 text-xl font-bold tracking-tight tabular-nums ${value === 0 ? 'text-gray-400' : 'text-gray-900'}`}>{fmtXof(value)}</p>
    <p className="mt-1 text-[11px] text-gray-400">{sub}</p>
  </div>
);

// Section « Commissions » — 4 cartes
export const CommissionCards = ({ commissions }) => {
  const c = commissions || {};
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-4" data-testid="perf-commission-cards">
      <Card icon={Clock} value={c.toValidate || 0} label="À valider" sub={`${c.toValidate ? '' : '0 '}commission(s) à valider`} testid="comm-card-tovalidate"
        ring={{ icon: 'bg-orange-100 text-orange-600', badge: 'bg-orange-50 text-orange-700' }} />
      <Card icon={CheckCircle2} value={c.approved || 0} label="Approuvées" sub="En attente de versement" testid="comm-card-approved"
        ring={{ icon: 'bg-amber-100 text-amber-600', badge: 'bg-amber-50 text-amber-700' }} />
      <Card icon={Wallet} value={c.paid || 0} label="Versées" sub="Déjà encaissées" testid="comm-card-paid"
        ring={{ icon: 'bg-emerald-100 text-emerald-600', badge: 'bg-emerald-50 text-emerald-700' }} />
      <Card icon={AlertCircle} value={c.remaining || 0} label="Reste à payer" sub="À verser aux commerciaux" testid="comm-card-remaining"
        ring={{ icon: 'bg-red-100 text-red-600', badge: 'bg-red-50 text-red-700' }} />
    </div>
  );
};

export default CommissionCards;
